import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import {
  Tes,
  TesAutocompleteFilters,
  tesAutocompleteQuery,
} from "./customerAPI";

type SliceState = {
  status: "idle" | "pending" | "succeeded" | "failed";
};

// TODO: add requestId
export const fetchTesDefinitions = createAsyncThunk<
  Tes[],
  TesAutocompleteFilters,
  { state: RootState }
>(
  "tes/fetchTesDefinitions",
  async (filters: TesAutocompleteFilters) =>
    await tesAutocompleteQuery(filters),
);

const tesSlice = createSlice({
  name: "tes",
  initialState: {
    status: "idle",
  } as SliceState,
  reducers: {},
});

export const tesReducer = tesSlice.reducer;
